import React from "react";

const ErrorController = ({ messsage = "Data not found" }) => {
  return <div>{messsage}, Please try again later</div>;
};

export default ErrorController;
